import "./App.css";
import HomePage from "./pages/HomePage";
import Right from "./components/Right";
import Middle from "./components/Middle";
import ParticleHeaderBg from "./components/ParticleHeaderBg";
import JourneyTimeline from "./components/JourneyTimeline";
import Semantic from "./components/Semantic";
import SkillsShowcase from "./components/Skills";
import Projects from "./components/Projects";
import WhereToFindMe from "./components/WhereToFindMe";

function App() {
  return (
    <>
      <ParticleHeaderBg />
      <div className="flex justify-center">
        <JourneyTimeline />
      </div>
        <SkillsShowcase />
        <Projects/>
        <WhereToFindMe/>
    </>
  );
}

export default App;
